<template>
  <div class="cpa-box-root">
    <!-- Header -->
    <div class="cpa-header">
      <div class="cpa-title">Support Questions</div>
      <div class="cpa-close" @click="$emit('close')">
        <i class="el-icon-close"></i>
      </div>
    </div>

    <!-- Body -->
    <div class="cpa-body">
      <div class="cards-wrapper" v-if="question">
        <!-- Concrete Card -->
        <div class="cpa-card" v-if="question.concrete">
          <div class="card-title">
            <img src="@/assets/Concrete.svg" class="cpa-svg-icon" />
            <span>Concrete</span>
          </div>

          <div v-if="question.concrete.cover" class="image-wrapper">
            <img :src="hashToUrl(question.concrete.cover)" alt="Concrete Cover" />
          </div>

          <div class="card-script">
            {{ question.concrete.script }}
          </div>

          <div class="card-actions">
            <button class="full-view-btn" @click="openFullView('concrete')">Full View <i class="el-icon-right"></i></button>
          </div>
        </div>

        <!-- Pictorial Card -->
        <div class="cpa-card" v-if="question.pictorial">
          <div class="card-title">
            <img src="@/assets/Pictorial.svg" class="cpa-svg-icon" />
            <span>Pictorial</span>
          </div>

          <div class="image-wrapper">
            <img :src="hashToUrl(question.pictorial.cover)" alt="Pictorial Cover" />
          </div>

          <div class="card-script">
            {{ question.pictorial.script }}
          </div>

          <div class="card-actions">
            <button class="full-view-btn" @click="openFullView('pictorial')">Full View <i class="el-icon-right"></i></button>
          </div>
        </div>
      </div>

      <div v-else class="no-data">
        <i class="el-icon-warning-outline"></i>
        No CPA support data available for this question.
      </div>
    </div>

    <!-- Full Screen Modal (Interactive View) -->
    <transition name="fade">
      <div v-if="dialog" class="full-modal">
        <div class="modal-header">
          <div class="modal-title">{{ selectedKey === 'concrete' ? 'CONCRETE' : 'PICTORIAL' }} INTERACTIVE VIEW</div>
          <button class="close-btn" @click="dialog = false"><i class="el-icon-close"></i> CLOSE</button>
        </div>

        <iframe :src="hashToUrl(question[selectedKey].data)" class="iframe" frameborder="0"></iframe>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'CpaBox',
  props: {
    question: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      dialog: false,
      selectedKey: null,
    }
  },
  methods: {
    hashToUrl(hash) {
      if (!hash) return ''
      return window.Fn && window.Fn.hashToUrl ? window.Fn.hashToUrl(hash) : hash
    },
    openFullView(type) {
      this.selectedKey = type
      this.dialog = true
    },
  },
}
</script>

<style scoped>
.cpa-box-root {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

/* Header */
.cpa-header {
  height: 56px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}
.cpa-title {
  font-size: 18px;
  font-weight: 500;
  color: #111;
}
.cpa-close {
  font-size: 20px;
  color: #333;
  cursor: pointer;
  transition: 0.2s;
}
.cpa-close:hover {
  transform: scale(1.1);
}

/* Body */
.cpa-body {
  padding: 24px;
  background: #fdfdfd; /* Very light gray background like in screenshot */
}

.cards-wrapper {
  display: flex;
  gap: 20px;
  justify-content: center;
}

/* Card Style */
.cpa-card {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #eee;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Soft shadow */
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.card-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.card-title span {
  font-size: 1.25rem;
  font-weight: 500;
  color: #111;
}
.cpa-svg-icon {
  width: 1.6rem;
  height: 1.6rem;
  object-fit: contain;
}

.image-wrapper {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 12px;
}
.image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
}

.card-script {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  flex: 1;
}

.card-actions {
  display: flex;
  justify-content: center;
}

.full-view-btn {
  width: 100%;
  padding: 10px;
  background: transparent;
  border: 1px solid #111; /* Sharp black-ish border like Quasar outline btn */
  border-radius: 24px; /* Rounded pill shape */
  color: #111;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: 0.2s;
}
.full-view-btn:hover {
  background: #f5f5f5;
}

/* No Data */
.no-data {
  text-align: center;
  padding: 40px;
  color: #999;
}
.no-data i {
  font-size: 40px;
  margin-bottom: 10px;
}

/* Full Modal (Interactive View) */
.full-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  z-index: 10002;
}

.modal-header {
  height: 56px;
  padding: 0 24px;
  background: #111; /* Standard dark header for full-view like in Quasar */
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.modal-title {
  font-weight: bold;
  color: #fff;
  font-size: 14px;
  letter-spacing: 1px;
}
.close-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  padding: 6px 16px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: 0.2s;
}
.close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
}

.iframe {
  flex: 1;
  width: 100%;
  height: 100%;
  border: none;
  display: block;
  margin-top: 0px;
}

/* Mobile Optimisation: Keep horizontal but reduce sizes */
@media (max-width: 768px) {
  .cpa-body {
    padding: 12px;
  }
  .cards-wrapper {
    gap: 10px;
  }
  .cpa-card {
    padding: 10px;
  }
  .card-title {
    gap: 8px;
    margin-bottom: 8px;
  }
  .card-title span {
    font-size: 0.9rem;
  }
  .cpa-svg-icon {
    width: 1.2rem;
    height: 1.2rem;
  }
  .image-wrapper {
    margin-bottom: 8px;
  }
  .card-script {
    font-size: 11px;
    margin-bottom: 12px;
    line-height: 1.4;
  }
  .full-view-btn {
    padding: 6px;
    font-size: 11px;
  }
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
